import React, { useState } from "react";
import { useComponentContext } from "../../contexts/component-context";
import { DrawerContextProvider } from "../../contexts/drawer-context";
import { sharedContext } from "../../contexts/shared-context";
import Header from "../Header/Header";
import Toolbar from "@mui/material/Toolbar";
import Drawer from "../Drawer/Drawer";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { clearPersistentStorage } from "../../Utils/usePersistentStorage";
import { closeSocket } from "../../components/Main/Main";
import NoAccess from "../NoAccess/NoAccess";

const Layout = ({ children }) => {
    const [companyId, setCompanyId] = useState("");
    const navigate = useNavigate();
    const { setSelectedComponent } = useComponentContext();
    const [axiosRemoveDialog, setAxiosRemoveDialog] = React.useState(false);
    const handleChange = data => {
        // take parameter passed from Child component
        setCompanyId(data);
    };

    // intercept axios error globally 
    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            if (error.response.status === 401 || error.response.data.message == 'Access Denied') {
                setAxiosRemoveDialog(true);
                closeSocket();
                setSelectedComponent(<NoAccess/>);
                setTimeout(() => {
                    navigate('/');
                }, 2000);
                clearPersistentStorage();
                sessionStorage.clear();
                return Promise.reject(error)
            }
            return Promise.reject(error)
        }
    )

    return (

        <DrawerContextProvider>
            <div style={{
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh'
            }}>
                <Header handleChange={handleChange} />
                <Toolbar />
                <div style={{ display: 'flex', flex: 1, background: '#F7F7F8' }}>
                    <Drawer />
                    <sharedContext.Provider value={companyId}>
                        <main className="containerElevated" style={{ flex: 1 }}>{children}</main>
                    </sharedContext.Provider>
                </div>
                <dialog id="dialogAxios" open={axiosRemoveDialog} className='sessionDialog' style={{ margin: '200px 0 0 90px' }}>
                    <div>
                        <p>Your session was removed from server, logging you off !!</p>
                    </div>
                </dialog>
            </div>
        </DrawerContextProvider>

    );
};

export default Layout;